import { FC, PropsWithChildren, useEffect } from 'react';
import cls from 'classnames';
import CloseIcon from 'icon/x_mark_fill.svg';
import { FixBodyUtil } from '~/utils/fix-body';

import './style.scss';

interface ActionPanelProps {
  className?: string;
  open: boolean;
  title: string;
  onClickClose: () => void;
  onClickMask: () => void;
}

export const ActionPanel: FC<PropsWithChildren<ActionPanelProps>> = ({
  open,
  title,
  children,
  onClickClose,
  onClickMask,
  className,
}) => {
  useEffect(() => {
    if (open) {
      FixBodyUtil.fix();
    } else {
      FixBodyUtil.restore();
    }

    return () => {
      FixBodyUtil.restore();
    };
  }, [open]);

  return (
    <div className={cls('action-panel-wrapper', { open, close: !open }, className)}>
      <div className="action-panel-mask" onClick={onClickMask} />
      <div className={cls('action-panel')}>
        <div className="action-panel-head">
          <p>{title}</p>
          <CloseIcon onClick={onClickClose} />
        </div>
        <div className="action-panel-divider" />
        <div className="action-panel-content">{children}</div>
      </div>
    </div>
  );
};
